export default "__VITE_ASSET__BsYq5NgF__"